import { Component, OnDestroy, OnInit } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { NbDialogService } from '@nebular/theme';
import { ToasterService } from '../../../shared/services/toaster.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalConfirmComponent } from '../../../shared/components/modals/confirm/modal-confirm.component';
import { EquipmentService } from './equipment.service';
import { orderBy } from 'lodash';
import { Subscription } from 'rxjs';
import { Helper } from '../../../shared/helpers/helper';
import { CompaniesService } from '../companies/companies.service';
import { UserAuthService } from '../../../shared/services/user-auth.service';

@Component({
  selector: 'app-equipment',
  templateUrl: './equipment.component.html',
  styleUrls: ['./equipment.component.scss']
})
export class EquipmentComponent implements OnInit, OnDestroy {

  subscriptions: Subscription[] = [];
  pattern: any = /^[-_A-Za-z0-9\s]*((-_\s)*[-_A-Za-z0-9\s])*$/;
  companyId: number;
  submitted: boolean = false;
  loading: boolean = false;
  pageInfo: any = {
    totalCount: null,
    maxItem: null,
  };
  hideButton: boolean = false;
  data: any[] = [];
  tableSettings = {
    noDataMessage: null,
    actions: {
      columnTitle: 'Action'
    },
    edit: {
      editButtonContent: '<i class="icon-edit app-main-color-fg app-font-size-normal"></i>',
      saveButtonContent: '<i class="icon-check  app-main-color-fg app-font-size-normal"></i>',
      cancelButtonContent: '<i class="icon-cancel app-danger-color-fg app-font-size-normal"></i>',
      confirmSave: true,
    },
    delete: {
      deleteButtonContent: '<i class="icon-delete app-danger-color-fg app-font-size-normal"></i>',
      confirmDelete: true,
    },
    hideSubHeader: true,
    pager: {
      perPage: 24,
    },
    columns: {
      name: {
        title: 'Equipment Name',
        type: 'string',
        width: '95%',
        sort: false,
      },
    },
  };

  dataSource: any = new LocalDataSource();

  form: FormGroup;
  equipmentName: AbstractControl;

  constructor(private dialogService: NbDialogService,
              private toasterService: ToasterService,
              private equipmentService: EquipmentService,
              private userAuthService: UserAuthService,
              private companiesService: CompaniesService
              ) {
    const user = this.userAuthService.getUserInfo();
    this.companyId = user.companyId;
    this.createForm();
  }

  createForm() {
    this.form = new FormGroup({
      equipmentName: new FormControl('',
        Validators.compose([Validators.required,
        Validators.minLength(2),
        Validators.maxLength(50),
        Validators.pattern(this.pattern)])
      ),
    });
    this.equipmentName = this.form.controls['equipmentName'];
  }

  ngOnInit() {
    this.getCompanyInfo();
  }

  ngOnDestroy(): void {
    Helper.unsubscribe(this.subscriptions);
  }

  onEditConfirm(event): void {
    if (event) {
      event.newData.name = event.newData.name.trim();
      event.newData.name = event.newData.name.replace(/\s+/g, ' ');
      const name = event.newData.name.trim();
      if (name.length >= 2 && name.length <= 50 && this.pattern.test(name)) {
        const param: any = {
          name
        };
        this.subscriptions.push(this.equipmentService.update(event.newData.id, param).subscribe(
          (res) => {
            this.loadData();
          }
        ));
      } else {
        this.toasterService.showError('The equipment name has to be between 2 and 50 characters long and not contain special chars (except for "-", space, underscore).');
      }
    }
  }

  onDeleteConfirm(item): void {
    this.dialogService.open(ModalConfirmComponent, {
      context: {
        config: {
          title: 'Delete',
          message: `Are you sure you want to delete <br> <b class="h6">${item.data.name}</b>?`,
          className: 'pop-delete common-page',
          btnTxtConfirm: 'Yes',
          btnTxtCancel: 'No',
          data: item.data,
        }
      }
    }).onClose.subscribe(res => {
      if (res.confirm) {
        this.onDelete(res.data);
      }
    });
  }
  checkCountItem() {
    this.hideButton = this.pageInfo.maxItem <= this.pageInfo.totalCount;
  }

  onAddNew() {
    if (this.equipmentName.errors) {
      this.toasterService.showError('The equipment name has to be between 2 and 50 characters long and not contain special chars (except for "-", space, underscore).');
    } else {
      this.submitted = true;
      const param: any = {
        name: this.equipmentName.value,
      };
      this.subscriptions.push(
        this.equipmentService.create(param, () => {
          this.submitted = false;
        }).subscribe(
          (res) => {
            this.equipmentName.setValue('');
            this.loadData();
          }
        ));
    }
  }

  onDelete(e) {
    this.subscriptions.push(
      this.equipmentService.delete(e.id).subscribe(
        (res) => {
          this.loadData();
        }));
  }

  loadData() {
    this.loading = true;
    this.subscriptions.push(
      this.equipmentService.getAll().subscribe(
        (res) => {
          if (res) {
            const result = orderBy(res.result.items, ['id'], ['desc']);
            this.dataSource.load(result);
            this.pageInfo.totalCount = res.result.totalCount;
            this.checkCountItem();
          }
          this.loading = false;
        }, (error) => {
          this.loading = false;
        }
    ));
  }

  getCompanyInfo() {
    this.loading = true;
    this.subscriptions.push(
      this.companiesService.getCompanyId(this.companyId).subscribe(
        (res) => {
          this.pageInfo.maxItem = res.result.maxEquipment;
          this.loadData();
        }, (error) => {
          this.loading = false;
        }
      ));
  }
}
